<template>
  <div class="content">
    <h3>顺序码出库</h3>
    <div class="item">
      <el-form
        id="form"
        ref="form"
        :inline="true"
        :model="form"
        label-width="90px"
      >
        <el-form-item label="出库单号">
          <el-input
            placeholder="请输入单号"
            v-model="form.order"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="出库库房">
          <el-select v-model="form.storeId" @change="selChange" @focus="getStore" placeholder="请选择">
            <el-option
              v-for="item in warehouse"
              :key="item.StoreCode"
              :label="item.StoreName"
              :value="item.StoreCode"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="出库类型">
          <el-select v-model="form.operType" placeholder="请选择">
            <el-option
              v-for="item in outstock"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="经销商">
          <el-input
            placeholder="请选择经销商"
            v-model="form.dealer"
            :value="form.dealerId"
            @focus="dealerfocus"
          ></el-input>
        </el-form-item>

        <el-form-item label="操作方式" style="width:800px">
          <el-radio-group v-model="form.CodeType" style="display: inline-flex;">
            <el-radio :label="1">顺序码起始值</el-radio>
            <el-radio :label="2">输入顺序码</el-radio>
            <el-radio :label="3">上传文件</el-radio>
          </el-radio-group>
        </el-form-item>
        <div
          v-if="form.CodeType === 1"
          style="margin:0 0 10px; padding:10px 0 0 0;"
          class="item"
        >
          <el-form-item label="起始值">
            <el-input
              placeholder="请输入数值"
              v-model="form.startvalue"
              clearble
            ></el-input>
          </el-form-item>
          <el-form-item label="终止值">
            <el-input
              placeholder="请输入数值"
              v-model="form.endvalue"
              clearble
            ></el-input>
          </el-form-item>
          <div style="display:flex;">
            <el-form-item label="剔除数码" style="display:block;">
              <el-input
                placeholder="请输入数值"
                @keyup.enter.native="deletevalueChange"
                v-model="deletevalue"
                clearble
              ></el-input>
            </el-form-item>
            <div class="tag">
              <el-tag
                @close="romoveDeletevalue(index)"
                v-for="(tag, index) in form.deletevalue"
                :key="tag"
                closable
              >
                {{ tag }}
              </el-tag>
            </div>
          </div>
        </div>
        <div
          v-if="form.CodeType === 2"
          style="margin:0 0 10px; padding:10px 0 0 0;display:flex;"
          class="item"
        >
          <el-form-item label="操作数码">
            <el-input
              @keyup.enter.native="numChange"
              v-model="num"
              clearble
            ></el-input>
          </el-form-item>
          <div class="tag">
            <el-tag
              @close="numDeletevalue(index)"
              v-for="(tag, index) in form.CodeList"
              :key="tag"
              closable
            >
              {{ tag }}
            </el-tag>
          </div>
        </div>
        <div
          v-if="form.CodeType === 3"
          style="margin:0 0 10px; padding:10px 0 0 0;"
          class="item"
        >
          <el-form-item label="上传文件" style="display:block;width:100%;">
            <div style="width: 300px;display: -webkit-inline-box;">
              <el-upload style="width: 180px;"
                class="upload-demo"
                ref="upload"
                action="/FW/UploadFile.ashx"
                :auto-upload="false"
                :before-upload="beforeUpload"
                :on-change="change"
                :on-success="success"
                :data="uploadData"
                :file-list="fileList">
                <el-button icon="el-icon-search" type="primary">选择文件</el-button>
              </el-upload>
              <el-button icon="el-icon-upload" type="primary" @click="upload">上传文件</el-button>
            </div>
          </el-form-item>
        </div>
        <el-form-item label="备注" style="width:100%">
          <el-input
            style="width:830px"
            v-model="form.remark"
            clearble
          ></el-input>
        </el-form-item>
        <el-form-item style="width:800px;margin:0 80px;">
          <el-checkbox v-model="form.IsChange">修改产品相关信息</el-checkbox>
        </el-form-item>
        <div v-if="form.IsChange">
          <el-form-item label="产品">
            <el-input
              @focus="productfocus"
              v-model="form.product"
              :value="form.productCode"
              clearble
            ></el-input>
          </el-form-item>
          <el-form-item label="生产工厂">
            <el-select v-model="form.productfactory"  @focus="SelFactory" placeholder="请选择">
              <el-option
                v-for="item in factorytable"
                :key="item.FactoryCode"
                :label="item.FactoryName"
                :value="item.FactoryCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生产车间">
            <el-select v-model="form.production" @focus="SelWorkShop" placeholder="请选择">
              <el-option
                v-for="item in workShoptable"
                :key="item.Workshopcode"
                :label="item.Workshopname"
                :value="item.Workshopcode"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生产线">
            <el-select v-model="form.productionline" @focus="SelProductLine" placeholder="请选择">
              <el-option
                v-for="item in productlinetable"
                :key="item.LineId"
                :label="item.LineName"
                :value="item.LineId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生产班组">
            <el-select v-model="form.productionteam" @focus="SelShiftInfo" placeholder="请选择">
              <el-option
                v-for="item in shiftInfotable"
                :key="item.ShiftId"
                :label="item.ShiftName"
                :value="item.ShiftId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品批号">
            <el-input v-model="form.productionbatch" clearble></el-input>
          </el-form-item>
          <el-form-item label="供应商">
            <el-input v-model="form.supplier" clearble></el-input>
          </el-form-item>
          <el-form-item label="质检员">
            <el-input v-model="form.qc" clearble></el-input>
          </el-form-item>
          <el-form-item label="保质期(天)" >
            <el-input v-model="form.productiondate" clearble></el-input>
          </el-form-item>
          <el-form-item label="生产日期">
            <el-date-picker
              v-model="form.pd"
              value-format="yyyy-MM-dd"
              type="date"
              @change="datechange"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="截止有效期">
            <el-date-picker
              v-model="form.expirationdate"
              default-value="getCurrentDate()"
              value-format="yyyy-MM-dd"
              type="date"
              @change="datechange"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="checkout">出库</el-button>
      </div>
    </div>
    <el-dialog title="选择经销商" :visible.sync="dialogVisible" width="540px">
      <el-table
        :data="gridData"
        highlight-current-row
        @row-click="handleCurrentChange"
      >
        <el-table-column
          align="center"
          width="80"
          property="id"
          label="序号"
        ></el-table-column>
        <el-table-column
          align="center"
          width="120"
          property="DealerId"
          label="经销商编号"
        ></el-table-column>
        <el-table-column
          align="center"
          width="280"
          property="DealerName"
          label="经销商名称"
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择产品" :visible.sync="dialogVisible2" width="1040px">
      <el-form :inline="true" label-width="90px">
        <el-form-item label="产品编号">
          <el-input
            placeholder="请输入产品编号"
            v-model="form.product"
            clearble
          ></el-input>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input placeholder="请输入产品编号" clearble></el-input>
        </el-form-item>
        <el-form-item label="包装比例">
          <el-select v-model="form.outstate" placeholder="请选择">
            <el-option
              v-for="item in outstock"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table
        :data="productdata"
        highlight-current-row
        @row-click="handleCurrentChange"
      >
        <el-table-column
          align="center"
          width="80"
          property="id"
          label="序号"
        ></el-table-column>
        <el-table-column
          align="center"
          width="120"
          property="Productcode"
          label="产品编号"
        ></el-table-column>
        <el-table-column
          align="center"
          width="280"
          property="Productname"
          label="产品名称"
        ></el-table-column>
        <el-table-column
          align="center"
          width="280"
          property="Specid"
          label="产品品规"
        ></el-table-column>
        <el-table-column
          align="center"
          width="280"
          property="Norms"
          label="包装比例"
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="confirm2">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uploadData:null,
      fileList: [],
      dialogVisible: false,
      dialogVisible2: false,
      deletevalue: null,
      num: null,
      form: {
        order: "", //出库单号
        storeId: "", //出库库房
        operType: "", //出库类型
        dealerId: "", //经销商编码
        dealer: "", //经销商
        CodeType: 1, //操作方式

        uploadFile:[],

        startvalue: "", //起始值
        endvalue: "", //终止值
        deletevalue: [], //删除码

        CodeList: [], //顺序码

        remark: "", //备注
        IsChange: false, //修改选项
        product: "", //产品名称
        productCode: "", //产品编号
        productfactory: "", //生产工厂
        production: "", //生产车间
        productionline: "", //生产线
        productionteam: "", //生产班组
        productionbatch: "", //产品批号
        supplier: "", //供应商
        qc: "", //质检员
        productiondate: "", //保质期
        pd: "", //生产日期
        expirationdate: "" //截止日期
      },
      options: [
        {
          value: 1,
          label: "创建时间"
        },
        {
          value: 2,
          label: "更新时间"
        }
      ],
      warehouse: [],
      factorytable:[],
			workShoptable:[],
			productlinetable:[],
			shiftInfotable:[],
      outstock: [
        {
          value: 1,
          label: "销售出库"
        },
        {
          value: 2,
          label: "调拨出库"
        }
      ],
      gridData: [],
      productdata: [],
      current: null,
      tableData: []
    };
  },
  methods: {
    getCurrentDate(){
      return new Date().toString("YYYY-MM-DD")
    },
    numDeletevalue(index) {
      console.log(index);
      this.form.CodeList.splice(index, 1);
    },
    numChange(val) {
      this.form.CodeList.push(this.num);
      this.num = null;
    },
    romoveDeletevalue(index) {
      console.log(index);
      this.form.deletevalue.splice(index, 1);
    },
    deletevalueChange(val) {
      this.form.deletevalue.push(this.deletevalue);
      this.deletevalue = null;
    },
    change(files, fileList){

		},
		success(response, file, fileList){
      console.log(file);
      console.log(fileList);
			if(response.Code==0){
        this.form.uploadFile.push(file.name)
				this.$message({
				showClose: true,
				message: response.Msg,
				type: "success"
				});
			}else{
				this.$message({
				showClose: true,
				message: response.Msg,
				type: "warning"
				});
			}   
    },
    beforeUpload (file) {    
      var user = JSON.parse(sessionStorage.getItem('user'));
      this.uploadData = { cid: user.QyNum }; //上传携带的参数名 
      // this.uploadData = {dstype:this.proType,name:this.mobanname,dsmark:this.value5,};
      console.log(this.uploadData)
      let promise = new Promise((resolve) => {
          this.$nextTick(function () {
              resolve(true);
          });
      });
      return promise; //通过返回一个promis对象解决
     },
    upload(){
      
      console.log(this.user)
      this.$refs.upload.submit()
    },
    
    confirm() {
      this.form.dealer = this.current.DealerName;
      this.form.dealerId = this.current.DealerId;
      this.dialogVisible = false;
    },
    confirm2() {
      this.form.product = this.current.Productname;
      this.form.productCode = this.current.Productcode;
      this.dialogVisible2 = false;
    },
    handleCurrentChange(data) {
      this.current = data;
    },

    productfocus(){
			//	请求产品数据
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Product.ashx',
				params:{
					action:"query",
					cid:user.QyNum
				}
			}).then(res=>{
					if(res.Code==0){
            this.productdata=res.DataList;
            this.dialogVisible2 = true
          }else{
						this.$message({
						showClose: true,
						message: res.Msg,
						type: "warning"
          });
        }
			})
		},

    dealerfocus() {
      //	请求经销商数据
      var user = JSON.parse(sessionStorage.getItem('user'));
      this.$axios({
        method: "post",
        url: "/FW/Dealer.ashx",
        params: {
					action:"query",
					cid:user.QyNum
				}
      }).then(res => {
        if(res.Code==0){
            this.gridData = res.DataList;
            this.dialogVisible = true;
        }else{
						this.$message({
						showClose: true,
						message: res.Msg,
						type: "warning"
					});
				}     
      });
      
    },

    //请求出库库房数据
    getStore(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Store.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
					if(res.Code==0){
						this.warehouse=res.DataList;
					}else{
						this.$message({
						showClose: true,
						message: res.Msg,
						type: "warning"
					});
				}      
			})
    },

    selChange(){

    },

    datechange(){
      if(this.form.pd !=null && this.form.pd.length!=0&&this.form.expirationdate !=null && this.form.expirationdate.length!=0){
        //date1开始时间
        let date1 = new Date(this.form.pd);
        //date2截止时间
        let date2 = new Date(this.form.expirationdate);
        date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
        date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
        const diff = date2.getTime() - date1.getTime(); //目标时间减去当前时间
        const diffDate = diff / (24 * 60 * 60 * 1000);  //计算当前时间与结束时间之间相差天数
        this.form.productiondate=diffDate
      }
    },
    
    SelFactory(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			//查询工厂
			this.$axios({
        		method: 'post',
        		url:'/FW/Factory.ashx',
        		params: {
          			action:"query",
					      cid:user.QyNum
        		}
        	}).then(res=>{
          		if(res.Code==0){
					console.log(res);
					this.factorytable=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})		
		},

		SelWorkShop(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			if(this.form.productfactory==null || this.form.productfactory.length==0){
				this.$message({
            			showClose: true,
            			message:"请先选择工厂",
            			type: 'warning'
					});
					return;
			}
			//查询车间
			this.$axios({
        		method: 'post',
        		url:'/FW/WorkShop.ashx',
        		params: {
          			action:"query",
					cid:user.QyNum,
					factoryID:this.form.outstore
        		}
        	}).then(res=>{
          		if(res.Code==0){
					console.log(res);
					this.workShoptable=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})		
		},

		SelProductLine(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			if(this.form.production==null || this.form.production.length==0){
				this.$message({
            			showClose: true,
            			message:"请先选择车间",
            			type: 'warning'
					});
					return;
			}
			//查询生产线
			this.$axios({
        		method: 'post',
        		url:'/FW/ProductLine.ashx',
        		params: {
          			action:"query",
					cid:user.QyNum,
					factoryID:this.form.outstore,
					WorkshopId:this.form.cj
        		}
        	}).then(res=>{
          		if(res.Code==0){
					console.log(res);
					this.productlinetable=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})		
		},

		SelShiftInfo(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			if(this.form.productionline==null || this.form.productionline.length==0){
				this.$message({
            			showClose: true,
            			message:"请先选择生产线",
            			type: 'warning'
					});
					return;
			}
			//查询班组
			this.$axios({
        		method: 'post',
        		url:'/FW/ShiftInfo.ashx',
        		params: {
              action:"query",
              cid:user.QyNum,
					    FactoryID:this.form.outstore,
					    WorkshopID:this.form.cj,
					    LineID:this.form.scx
        		}
        	}).then(res=>{
          		if(res.Code==0){
					      console.log(res);
					      this.shiftInfotable=res.DataList
          		}else{
					      this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})		
		},

    checkout() {
      var user = JSON.parse(sessionStorage.getItem("user"));
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      var date = yy + "-" + mm + "-" + dd;
      console.log(this.form);
      this.$axios({
        method: "post",
        url: "/FW/OutData.ashx",
        params: {
          //用户信息
          user: user,
          action:"SeqOutOrderCode",
          //表单信息
          dealer: this.form,
          //提交时间
          date: date
        }
      }).then(res => {
        if(res.Code==0){
					      console.log(res);
					      this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'success'
            		});
          		}else{
					      this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      });
    }
  }
};
</script>

<style scoped>
.title {
  text-align: left;
}
.btn {
  width: 500px;
  margin: 0px 90px;
}
.el-form--inline .el-form-item {
  width: 300px;
  margin-bottom: 10px;
}
.el-input,
.el-select {
  width: 200px;
}
.el-checkbox {
  line-height: 19px;
}
.el-radio {
  line-height: 16px;
}
.tag {
  /*margin: 20px 0;*/
  display: flex;
  align-items: center;
}
.tag .el-tag {
  margin-left: 20px;
}
</style>
<style >
#form .el-upload-list {
  width: 900px !important;
}
#form .el-upload-list--picture .el-upload-list__item {
  width: 300px;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/pages/outStoreSeqCode.vue